import { createPortal } from 'react-dom';
import { useCrmPageNotifications } from '../../contexts/CrmPageNotificationsContext';
import { PageNotificationToast } from './PageNotificationToast';

type CrmPageToastPortalProps = {
  onOpen?: () => void;
};

export function CrmPageToastPortal({ onOpen }: CrmPageToastPortalProps) {
  const { activeToast, dismissToast } = useCrmPageNotifications();

  if (!activeToast) return null;

  return createPortal(
    <PageNotificationToast
      notification={activeToast}
      onDismiss={dismissToast}
      onOpen={onOpen}
    />,
    document.body,
  );
}
